import { render, staticRenderFns } from "./MEsg.vue?vue&type=template&id=15c0eac6&"
import script from "./MEsg.vue?vue&type=script&lang=js&"
export * from "./MEsg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports